<script>
  export let selected = '';
  const countries = [
    {
      flag: '🇧🇪',
      name: 'Belgium',
      url: '/be/nl/',
    },
    {
      flag: '🇧🇷',
      name: 'Brazil',
      url: '/br/pt/',
    },
    {
      flag: '🇧🇬',
      name: 'Bulgaria',
      url: '/bg/bg/',
    },
    {
      flag: '🇨🇴',
      name: 'Colombia',
      url: '/co/es/',
    },
    {
      flag: '🇩🇰',
      name: 'Denmark',
      url: '/dk/da/',
    },
    {
      flag: '🇪🇬',
      name: 'Egypt',
      url: '/eg/ar/',
    },
    {
      flag: '🇫🇮',
      name: 'Finland',
      url: '/fi/fi/',
    },
    {
      flag: '🇫🇷',
      name: 'France',
      url: '/fr/fr/',
    },
    {
      flag: '🇩🇪',
      name: 'Germany',
      url: '/de/de/',
    },
    {
      flag: '🇮🇸',
      name: 'Iceland',
      url: '/is/is/',
    },
    {
      flag: '🇮🇳',
      name: 'India',
      url: '/in/en/',
    },
    {
      flag: '🇮🇩',
      name: 'Indonesia',
      url: '/id/id',
    },
    {
      flag: '🇮🇱',
      name: 'Israel',
      url: '/il/he/',
    },
    {
      flag: '🇮🇹',
      name: 'Italy',
      url: '/it/it/',
    },
    {
      flag: '🇲🇽',
      name: 'Mexico',
      url: '/mx/es/',
    },
    {
      flag: '🇳🇱',
      name: 'Netherlands',
      url: '/nl/nl/',
    },
    {
      flag: '🇳🇴',
      name: 'Norway',
      url: '/no/nn/',
    },
    {
      flag: '🇵🇱',
      name: 'Poland',
      url: '/pl/pl/',
    },
    {
      flag: '🇸🇦',
      name: 'Saudi Arabia',
      url: '/sa/ar/',
    },
    {
      flag: '🇸🇬',
      name: 'Singapore',
      url: '/sg/en/',
    },
    {
      flag: '🇰🇷',
      name: 'South Korea',
      url: '/kr/ko/',
    },
    {
      flag: '🇪🇸',
      name: 'Spain',
      url: '/es/es/',
    },
    {
      flag: '🇸🇪',
      name: 'Sweden',
      url: '/se/sv/',
    },
    {
      flag: '🇹🇭',
      name: 'Thailand',
      url: '/th/th/',
    },
    {
      flag: '🇹🇷',
      name: 'Turkey',
      url: '/tr/tr/',
    },
    {
      flag: '🇦🇪',
      name: 'United Arab Emirates',
      url: '/ae/ar/',
    },
  ];

  const selectedCountry = countries.find((c) => c.name === selected) || {
    name: '',
    flag: '',
  };
  const maybeHostedCountries =
    selected !== 'Denmark'
      ? countries.map((country) =>
          country.name !== 'Denmark'
            ? country
            : { ...country, url: `https://mofibo.com${country.url}` }
        )
      : countries.map((country) =>
          country.name === 'Denmark'
            ? country
            : { ...country, url: `https://www.storytel.com${country.url}` }
        );
</script>

<style lang="scss">
  @import '../../styles/tools/media-query';
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';

  svg:not(:root) {
    overflow: hidden;
  }

  .country-picker {
    font-size: 16px;
    font-stretch: 100%;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: 24px;
    overflow-wrap: break-word;
    text-size-adjust: 100%;
    text-transform: none;
    word-break: keep-all;
  }

  .country-checkbox {
    position: absolute;
    width: 1px;
    height: 1px;
    border: 0;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0 0 0 0);
  }

  .country-label {
    background-color: $white;
    border-radius: 4px;
    cursor: default;
    display: block;
    padding: spacing(2) spacing(3);
    position: relative;
    width: 27rem;
    color: $black;
    border: 1px solid $grey-20;
  }

  .country-checkbox:checked + label {
    color: $orange-50;
    border-color: $orange-50;
  }

  .country-flag {
    display: inline-block;
    width: 4rem;
    vertical-align: middle;
  }

  .country-name {
    vertical-align: middle;
  }

  .country-checkbox:checked + label > svg {
    transform: rotate(180deg);
  }

  .chevron {
    width: 1.7rem;
    height: 1.6rem;
    position: absolute;
    right: 1.6rem;
    top: 2.2rem;
    vertical-align: middle;
    max-width: 100%;
  }

  :global([dir='rtl']) {
    .chevron {
      right: auto;
      left: 1.6rem;
    }
  }

  .country-list {
    display: none;
    margin: 0;
    opacity: 0;
    box-shadow: 0 3px 6px rgba($black, 0.16), 0 3px 6px rgba($black, 0.23);
    width: 27rem;
    padding: spacing(3);
    list-style: none;
  }

  .country-checkbox:checked ~ .country-list {
    display: block;
    opacity: 1;
  }

  .country-item:not(:last-child) {
    margin-block-end: spacing(3);
  }

  .country-link {
    color: inherit;
    text-decoration: none;
    font-weight: normal;

    &:hover {
      color: $orange-50;
    }
  }
</style>

<div class="country-picker">
  <input
    type="checkbox"
    id="footerCountryCheckbox"
    class="country-checkbox"
    role="button"
    aria-expanded="false"
    autocomplete="off"
  />
  <label for="footerCountryCheckbox" id="footerCountryCheckboxLabel" class="country-label">
    <span
      id="footerSelectedCountryFlag-{selectedCountry.name}"
      class="country-flag"
      role="img"
      aria-hidden="true"
    >
      {selectedCountry.flag}
    </span>
    <span id="footerCurrentCountryName" class="country-name">{selectedCountry.name}</span>
    <svg
      id="footerCountryIcon"
      class="chevron u-animation__all--ease-in-out-300"
      aria-label="Country picker, {selectedCountry.name}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 16"
    >
      <path
        fill="#000"
        fill-rule="evenodd"
        d="M13.678 5.69l-.516-.516a.313.313 0 0 0-.442 0L8.004 9.88 3.287 5.174a.313.313 0 0 0-.442
        0l-.516.516a.313.313 0 0 0 0 .443l5.453 5.453c.123.122.32.122.443 0l5.453-5.453a.313.313 0 0
        0 0-.443z"
      />
    </svg>
  </label>
  <ul class="country-list" id="footerCountryList">
    {#each maybeHostedCountries as country}
      <li class="country-item">
        <a class="js-footerCountryListLink country-link" rel="external" href={country.url}>
          <span
            id="footerCurrentCountryFlag-{country.name}"
            class="country-flag"
            role="img"
            aria-hidden="true"
          >
            {country.flag}
          </span>
          <span class="country-name">{country.name}</span>
        </a>
      </li>
    {/each}
  </ul>
</div>
